<template>
  <div id="app">
     <!-- <Login/> -->
     <router-view/>
  </div>
</template>

<script>
// import axios from 'axios'
// import Login from '@/components/Login.vue'
export default {
  name: 'app',
  // components: {
  //   Login
  // }
  // mounted () {
  //   // loading
  //   // this.getLoading()
  //   // 获取地图
  //   // this.getMap()
  // }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
  /* margin-top: 60px; */
}
</style>
